import { Button, ButtonProps, styled } from "@mui/material";

const StyledButton = styled(Button)(() => ({
  boxShadow: "none",
}));

export function OLButton(props: ButtonProps) {
  return <StyledButton {...props} size={props.size || "medium"} />;
}
